/** @format */

import { Box, Stack, Typography } from '@mui/material';
import FamilyRestroomOutlined from '@mui/icons-material/FamilyRestroomOutlined';
import { useAppSelector } from '../../../../app/hooks';
import CircularLoader from '../../../../common/loaders/circularLoader';
import { selectApplicant } from '../../ApplicantSlice';
import { ApplicationDetailsDto } from '../../Models';
import DisplayGuardians from '../../components/Guardian/DisplayGuardians';

interface Props {
  applicant: ApplicationDetailsDto | null;
}
export default function GuardianInfo({ applicant }: Props) {
  const applicantSelect = useAppSelector(selectApplicant);

  return (
    <>
      {applicant && (
        <Box>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1}
            alignItems={{ xs: 'flex-start', sm: 'center' }}
            sx={{ mb: 2.5 }}>
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: (t) =>
                  t.palette.mode === 'light'
                    ? 'rgba(25, 118, 210, 0.08)'
                    : 'action.selected',
                color: 'primary.main',
              }}>
              <FamilyRestroomOutlined />
            </Box>
            <Box>
              <Typography variant='h6' sx={{ fontWeight: 800 }}>
                Guardian details
              </Typography>
              <Typography variant='body2' color='text.secondary'>
                Household members responsible for your application.
              </Typography>
            </Box>
          </Stack>
          <CircularLoader status={applicantSelect.loginState.status} />

          <DisplayGuardians
            formik={undefined}
            guardians={applicant && applicant.guardian?.guardians}
          />
        </Box>
      )}
    </>
  );
}
